import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreeNode } from '../../models';
import * as hexRgb from 'hex-rgb';


@Component({
  selector: 'checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent {

  @Input('node') node: TreeNode;
  @Output('onChange') change: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  emitChange(){
    this.node.checked = !this.node.checked;
    this.change.emit(this.node.checked)
  }

  useDarkCheck(node: TreeNode): boolean {
    if(!node.filter.color) return false;
    const rgb: number[] = hexRgb(node.filter.color, {format: 'array'});
    return rgb[0] > MAX_CONTRAST && rgb[1] > MAX_CONTRAST && rgb[2] > MAX_CONTRAST;
  }
}

const MAX_CONTRAST = 150;
